module.exports = __webpack_public_path__ + "static/media/swimmy-logo.7d60a522.png";